/* eslint-disable */
import { CheckCircleFilled } from '@ant-design/icons';
import { Form, Input, Modal, ModalProps, Spin, Typography } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SNBL_PATH } from 'src/configs/AppConfig';
import { COLOR_2, COLOR_3 } from 'src/constants/ChartConstant';
import useAppMutation from 'src/hooks/useAppMutation';
import useAppSearchParams from 'src/hooks/useAppSearchParams';
import { IUserValidateOTP } from 'src/services/UserService';
import getErrorMessage from 'src/utils/getError';

interface ValidateOTPModalProps {
  phoneNumber: string;
  modalProps: ModalProps;
}

const ValidateOTPModal: React.FC<ValidateOTPModalProps> = ({ phoneNumber, modalProps }) => {
  const navigate = useNavigate();
  const { searchParamsString } = useAppSearchParams();

  const [form] = Form.useForm<IUserValidateOTP>();
  const [pin, setPin] = useState('');

  const {
    error: errorValidatingOTP,
    isPending: validatingOTP,
    mutate: validateOtpMutate,
    isSuccess,
  } = useAppMutation<IUserValidateOTP>('/users/v1/self/validateUserOtp', {
    onSuccess: () => {
      navigate(`${SNBL_PATH}/pin-creation?${searchParamsString}`);
    },
  });

  const onChange = (text: string) => {
    setPin(text);

    if (text.length === 6) {
      validateOtpMutate({ phoneNumber, registrationType: 'CUSTOMER', otp: text });
    }
  };

  return (
    <Modal {...modalProps} footer={null} destroyOnClose title="Enter the OTP sent to your phone number" width="min-content">
      {isSuccess ? (
        <div style={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center', paddingTop: '20px' }}>
          <CheckCircleFilled color="success" style={{ color: COLOR_2, fontSize: 36 }} />
          <Typography.Title level={5}>OTP Success</Typography.Title>
        </div>
      ) : (
        <Form form={form} layout="inline" name="validate-otp-form" className="d-flex align-items-center gap-2 w-100 mt-4">
          <Form.Item hasFeedback name="otp">
            <Input.OTP value={pin} onChange={onChange} style={{ width: '250px' }} length={6} itemType="number" />
          </Form.Item>
          {validatingOTP && <Spin />}
          <p style={{ color: COLOR_3 }}>{errorValidatingOTP && getErrorMessage(errorValidatingOTP)}</p>
        </Form>
      )}
    </Modal>
  );
};

export default ValidateOTPModal;
